<template>
	<div v-if="item">
		<v-container
			v-if="item"
			class="container--narrow"
		>
			<v-card>
				<v-card-title v-text="item.title" />
				<v-divider />
				<v-card-text>
					<SchemaToForm
						v-model="formData"
						:schema="config.forms.membership"
						:disabled="formLoading"
						:debug="false"
						@valid="formValid = true"
						@invalid="formValid = false"
						@change="$store.commit('setConfirmNavigation', true)"
					/>
				</v-card-text>
				<v-divider />
				<v-card-actions>
					<v-subheader>
						Peruutus vahvistetaan heti.
					</v-subheader>
					<v-spacer />
					<v-btn
						color="error"
						text
						:disabled="formLoading"
						@click="(confirmationDialog = true)"
					>
						Peruuta jäsenyytesi
					</v-btn>
				</v-card-actions>
			</v-card>
			<!-- confirmation dialog -->
			<v-dialog
				v-model="confirmationDialog"
			>
				<v-card>
					<v-card-title>
						Jäsenyyden päättäminen
					</v-card-title>
					<v-divider />
					<!-- <v-card-text>
						Sit adipisicing dolore dolor occaecat laborum dolore do dolore sunt non deserunt ex esse quis consequat fugiat labore.
					</v-card-text>
					<v-divider /> -->
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="error"
							text
							:disabled="formLoading"
							@click="resign"
						>
							Kyllä, eroan syöpäyhdistyksestä
						</v-btn>
						<v-spacer />
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-container>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Memmbership',

	data: () => ({
		item: null,
		formData: {},
		formLoading: false,
		confirmationDialog: false,
	}),

	computed: {
		...mapState({
			config: state => state.config,
			items: state => state.user.membership,
		}),
	},

	mounted () {
		this.loadItem()
	},

	methods: {
		loadItem () {
			this.item = this.items.find(item => {
				return item.name == this.$route.params.membershipName
			})

			if (!this.item) {
				this.$router.replace({ name: 'error404' })
			}

			this.formData = JSON.parse(JSON.stringify(this.item))
		},

		resign () {
			this.formLoading = true

			this.$api.Membership.doRequest({
				method: 'POST',
				body: this.formData,
			}).on('done', (res) => {
				if (res.body.memberData) {
					this.formData = res.body.memberData
				}

				// Clear navigation confirm
				if (!res.body.error){
					this.$nextTick(() => {
						this.$store.dispatch('clearConfirmNavigation')
						this.$api.Logout.pushRequest()
					})
				}
			}).on('finish', () => {
				this.formLoading = false
			})
		},
	},
}
</script>
